import routes from './routes';
import appConfig from './app';

const configs = {
    routes,
    appConfig,
};
export default configs;
